export const sectorColors = {
  'OBSOLETE.COM': '#FFFF00',
  'SCREEN': '#FF6B6B',
  'GAMES': '#4ECDC4',
  'MUSIC': '#A78BFA',
  'LIVE': '#22C55E',
  'CREATOR': '#3B82F6',
  'SOCIAL': '#F59E0B',
  'EDUCATION': '#60A5FA',
  'CRAFT': '#FB923C',
  'FASHION': '#EC4899',
  'ADVERTISING': '#F97316',
  'AI': '#E5E7EB',
  'INFRASTRUCTURE': '#94A3B8'
};
